import { Component, OnInit } from '@angular/core';
import { PaymentCredit, PaymentLine } from 'app/core/model/entity-model';
import { Utility } from 'app/core/utility';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { ValidationCallbackData } from 'devextreme/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-apply-credit-dialog',
    templateUrl: './apply-credit-dialog.component.html',
    styleUrls: ['./apply-credit-dialog.component.scss'],
    standalone: false,
})
export class ApplyCreditDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    validationGroup = 'applyCreditValidationGroup';

    credits: PaymentCredit[] = [];
    paymentLines: PaymentLine[] = [];

    creditId: number;
    paymentLineId: number;
    amount: number = 0;

    constructor(public modalRef: BsModalRef) {}

    ngOnInit() {
        if (this.paymentLineId || this.creditId) {
            this.setDefaultAmount();
        }
    }

    get selectedCredit(): any {
        return this.credits.find((x) => x.id === this.creditId);
    }

    get selectedLine(): any {
        return this.paymentLines.find((x) => x.id === this.paymentLineId);
    }

    get lineRemainingBalance(): number {
        const line = this.selectedLine;
        if (!line) return 0;
        return this.lineRemainingBalanceFor(line);
    }

    get maxApplicable(): number {
        const credit = this.selectedCredit;
        if (!credit || !this.selectedLine) return 0;
        return Utility.round(Math.min(credit.balance, this.lineRemainingBalance), 2);
    }

    creditDisplayExpr = (credit: any) => (credit ? `Credit #${credit.id} — Available: $${credit.balance.toFixed(2)}` : '');
    lineDisplayExpr = (line: any) => (line ? `${line.generatedDescription} — Remaining: $${this.lineRemainingBalanceFor(line).toFixed(2)}` : '');

    lineRemainingBalanceFor(line: any) {
        return Utility.round(line.startingBalance - (line.creditAmount || 0) - (line.amount || 0), 2);
    }

    onCreditChanged() {
        this.setDefaultAmount();
    }

    onLineChanged() {
        this.setDefaultAmount();
    }

    setDefaultAmount() {
        this.amount = this.maxApplicable > 0 ? this.maxApplicable : 0;
    }

    validateAmount = (e: ValidationCallbackData) => {
        if (!this.selectedCredit || !this.selectedLine) return false;
        return e.value > 0 && Utility.round(e.value, 2) <= this.maxApplicable;
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            return result.isValid;
        }
        return false;
    }

    apply() {
        if (!this.valid()) return;

        const credit = this.selectedCredit;
        const line = this.selectedLine;

        credit.balance = Utility.round(credit.balance - this.amount, 2);
        credit.applied = new Date();

        line.creditAmount = Utility.round((line.creditAmount || 0) + this.amount, 2);
        line.paymentCreditId = credit.id;
        this.result.next({ success: true });
    }

    close() {
        this.result.next({ success: false });
    }
}
